module.exports = __webpack_public_path__ + "img/cart-black.5f49bb0c.svg";